import { s_caf } from '../../../../i18n/strings/auto/wording_webview'

const ACCURACY_ERROR_TYPE_ORIGINAL = {
  0: s_caf.accuracy.error_type1,
  1: s_caf.accuracy.error_type2,
  2: s_caf.accuracy.error_type3,
  3: s_caf.accuracy.error_type4,
  4: s_caf.accuracy.error_type5,
  5: s_caf.accuracy.error_type6,
  6: s_caf.accuracy.error_type7,
  7: s_caf.accuracy.error_type8,
  8: s_caf.accuracy.error_type9,
  9: s_caf.accuracy.error_type10,
  10: s_caf.accuracy.error_type11,
  11: s_caf.accuracy.error_type12,
  12: s_caf.accuracy.error_type13,
}

const ACCURACY_ERROR_TYPE_EN = {
  0: s_caf.accuracy.error_type_en1,
  1: s_caf.accuracy.error_type_en2,
  2: s_caf.accuracy.error_type_en3,
  3: s_caf.accuracy.error_type_en4,
  4: s_caf.accuracy.error_type_en5,
  5: s_caf.accuracy.error_type_en6,
  6: s_caf.accuracy.error_type_en7,
  7: s_caf.accuracy.error_type_en8,
  8: s_caf.accuracy.error_type_en9,
  9: s_caf.accuracy.error_type_en10,
  10: s_caf.accuracy.error_type_en11,
  11: s_caf.accuracy.error_type_en12,
  12: s_caf.accuracy.error_type_en13,
}

export const mapAccuracyEnum = (category, t) => {
  return t(ACCURACY_ERROR_TYPE_ORIGINAL[category])
}

export const mapAccuracyEnumEN = (category, t) => {
  return t(ACCURACY_ERROR_TYPE_EN[category])
}
